import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcOffersLargeOl = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.5404 3.99592C16.2301 3.93323 16.9119 4.1801 17.4016 4.66976L27.3309 14.5991C28.2421 15.5103 28.2421 16.9877 27.3309 17.8989L17.9028 27.327C16.9916 28.2382 15.5142 28.2382 14.603 27.327L4.67366 17.3977C4.184 16.908 3.93713 16.2262 3.99983 15.5365L4.7855 6.8941C4.88748 5.77234 5.77625 4.88357 6.898 4.7816L15.5404 3.99592ZM15.9874 6.08397C15.9174 6.01402 15.82 5.97875 15.7215 5.98771L7.07907 6.77338C6.91882 6.78795 6.79186 6.91492 6.77729 7.07517L5.99161 15.7176C5.98266 15.8161 6.01792 15.9135 6.08788 15.9835L16.0172 25.9128C16.1474 26.0429 16.3584 26.0429 16.4886 25.9128L25.9167 16.4847C26.0469 16.3545 26.0469 16.1435 25.9167 16.0133L15.9874 6.08397ZM10.5 9C9.67157 9 9 9.67157 9 10.5C9 11.3284 9.67157 12 10.5 12C11.3284 12 12 11.3284 12 10.5C12 9.67157 11.3284 9 10.5 9Z",
		fill: "inherit"
	})
});
export default SvgIcOffersLargeOl;
